import i18n from "i18next";
import { initReactI18next } from "react-i18next";


// Traduzioni
const resources = {
  en: {
    translation: {
      "title_app": "Artworks by the main Italian artists that can be visited in Italy",
      "artist": "Artist",
      "title": "Title",
      "year": "Year",
      "tecnica": "Technique",
      "dimensioni": "Size",
      "provincia": "City",
      "galleria": "Location",
      "search": "🔍 Search on Google",
      "search_header": "Search",
      "search_provincia": "Search artworks by province",
      "search_artista": "Search artworks by artist",
      "select_provincia": "City (select =>):",
      "select_artista": "Artist (select =>):",
      "first_n": "First N artworks sorted by artist",
      "insert_n": "Insert N",
    }
  },
  it: {
    translation: {
      "title_app": "Opere dei principali artisti italiani visitabili in Italia",
      "artist": "Artista",
      "title": "Titolo",
      "year": "Anno",
      "tecnica": "Tecnica",
      "dimensioni": "Dimensioni",
      "provincia": "Provincia",
      "galleria": "Galleria",
      "search": "🔍 Cerca su Google",
      "search_header": "Cerca",
      "search_provincia": "Ricerca opere per provincia",
      "search_artista": "Ricerca opere per artista",
      "select_provincia": "Provincia (selezionare =>):",
      "select_artista": "Artista (selezionare =>):",
      "first_n": "Prime N opere ordinate per artista",
      "insert_n": "Inserisci N",
    }
  }
};

// Rileva la lingua del browser
const userLang = navigator.language.startsWith("it") ? "it" : "en";

i18n.use(initReactI18next).init({
  resources,
  lng: userLang, // Imposta la lingua iniziale
  interpolation: { escapeValue: false }
});

export default i18n;
